<app-auth-wrapper>
  <form [formGroup]="formGroup" (ngSubmit)="submit()" class="row g-3">

    <h4 class="mb-0">{{"AUTH.FORGOTTEN_PASSWORD"|translate}}</h4>

    <div class="col-sm-12">
      <app-form-input [id]="'email'"
                      [label]="('AUTH.EMAIL_ADDRESS'|translate)"
                      [controlName]="'email'"
                      [formGroup]="formGroup"
                      [type]="'email'"
                      [isRequired]="true"></app-form-input>
    </div>

    <div>
      <small><span class="fw-light">{{"AUTH.FORGOTTEN_PASSWORD_INFO"|translate}}.</span></small>
    </div>

    <div>
      <a [routerLink]="['/auth/login']"
         class="d-flex align-items-center gap-2">
        <i class="fas fa-arrow-left"></i>{{"AUTH.BACK_TO_LOGIN"|translate}}
      </a>
    </div>

    <!-- Submit button -->
    <div class="d-flex justify-content-center">
      <app-mdb-button [text]="'AUTH.REQUEST_RESET_LINK'"
                      [isSubmit]="true"
                      [loading]="loading"></app-mdb-button>
    </div>

  </form>
</app-auth-wrapper>
